import { render, staticRenderFns } from "./MultiSelectComponent.vue?vue&type=template&id=6350387e"
import script from "./MultiSelectComponent.vue?vue&type=script&lang=js"
export * from "./MultiSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports